export const getTourState = (state) => state.tourControl.runTour;
